import * as yup from 'yup'

export const bulkRefundFormValidationSchema = yup.object().shape({
    orders: yup
        .array()
        .min(1, 'Please select at least one order')
        .max(20, 'A maximum of 20 orders can be processed at one time')
        .required('Please select at least one order'),
})
